import { render, staticRenderFns } from "./AuctionDetailsPage.vue?vue&type=template&id=ddd42d74&scoped=true"
import script from "./AuctionDetailsPage.vue?vue&type=script&lang=js"
export * from "./AuctionDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./AuctionDetailsPage.vue?vue&type=style&index=0&id=ddd42d74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd42d74",
  null
  
)

export default component.exports